import type React from 'react'
import { cn } from '../../../shared/cn'

export function P3({ className, ...props }: React.ComponentPropsWithoutRef<'p'>) {
  return (
    <p {...props} className={cn('font-normal text-contentPrimary text-sm leading-5', className)} />
  )
}
